import './linked-movement-line.scss'

import { PropType } from "vue"
import Component from "vue-class-component"

import { Movement, getTranslatedString } from '@skinsoft/types'
import { movementSelectors } from "@skinsoft/selectors"
import { ReactiveVue } from "@skinsoft/reactive-vue"
import { Routes } from '../../../../router'
import { LINK_MOVEMENT_PAGE_NAVIGATE } from '../../../../events'

@Component({
    props: {
        movement: Object as PropType<Movement>
    },
    template: require('./linked-movement-line.html')
})
export class LinkedMovementLine extends ReactiveVue {
    private movement: Movement

    private get title(): string {
        return getTranslatedString(
            movementSelectors.indexTitle(this.movement) ?? movementSelectors.title(this.movement),
            this.getAppLocale()
        )
    }

    private get identificationNumber(): string {
        return movementSelectors.inventaryNumber(this.movement)
    }

    private onLinkClicked() {
        this.$emit(LINK_MOVEMENT_PAGE_NAVIGATE)
        this.$router.push({name: Routes.MOVEMENT, params: { id: this.movement.id }})
    }
}